export default {
    dateFormatData: 'yyyy-MM-dd',
    dateFormatUi: 'dd/MM/yyyy',
    dateFormatMonthYear: 'MMMM yyyy',
    dateFormatTime : 'hh:mm'
}